import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { Locality, Specialization } from '@hrra/common-models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { loadJobseekerSubscriptionLookup, loadSubscription, updateSelectedSpecializations, updateSubscription } from '../../root-store/jobseeker-store/jobseeker-subscription/actions';
import { selectJobseekerAtLeastOneSpecializationSelected, selectIsEditModeOn, selectJobseekerSpecializationTouched, selectJobseekerSelectedSpecializationIds, selectJobseekerSelectedSpecializationsMap, selectSubscriptionFormInitialValue, selectJobseekerSubscriptionLookup, selectJobseekerSubscriptionSpecializations, selectJobseekerSubscriptionIsLoading } from '../../root-store/jobseeker-store/jobseeker-subscription/selectors';
import { selectLocalities } from '../../root-store/selectors';
import { AppState } from '../../root-store/state';
import { Dictionary, UI_LIMITS } from '@hrra/core';
import { JobseekerLookupViewModel, JobseekerSpecializationViewModel } from '../shared/services/jobseeker.service';

@Component({
    selector: 'app-create-edit-subscription',
    templateUrl: './edit-jobseeker-subscription.component.html',
    styleUrls: ['./edit-jobseeker-subscription.component.scss'],
    standalone: false
})
export class EditJobseekerSubscriptionComponent implements OnInit {

  subscriptionForm: UntypedFormGroup;

  public headSpecializations$: Observable<Specialization[]>;
  public selectedSpecializationsMap$: Observable<Dictionary<boolean>>;
  public selectedSpecializations$: Observable<string[]>;
  public atLeastOneSpecializationSelected$: Observable<boolean>;
  public specializationsTouched$: Observable<boolean>;
  public localities$: Observable<Locality[]>;
  public isEditMode$: Observable<boolean>;

  public isLoading$: Observable<boolean>;

  public jobseekerSubscriptionLookup$: Observable<JobseekerLookupViewModel>;
  public jobseekerSubscriptionSpecializations$: Observable<JobseekerSpecializationViewModel[]>;

  public formInitialValue$: Observable<any>;

  public maxSelectedValue: number;

  constructor(private store: Store<AppState>, private router: Router) {
    this.subscriptionForm = new UntypedFormGroup({
      localities: new UntypedFormControl(null),
      seniorityLevels: new UntypedFormControl(null)
    });
    this.maxSelectedValue = UI_LIMITS.MAX_VISIBLE_SELECTED_ITEMS
  }

  ngOnInit(): void {
    this.atLeastOneSpecializationSelected$ = this.store.pipe(select(selectJobseekerAtLeastOneSpecializationSelected));

    this.selectedSpecializationsMap$ = this.store.pipe(select(selectJobseekerSelectedSpecializationsMap));

    this.selectedSpecializations$ = this.store.pipe(select(selectJobseekerSelectedSpecializationIds));

    this.specializationsTouched$ = this.store.pipe(select(selectJobseekerSpecializationTouched));

    this.localities$ = this.store.pipe(select(selectLocalities));

    this.isEditMode$ = this.store.pipe(select(selectIsEditModeOn));

    this.jobseekerSubscriptionLookup$ = this.store.select(selectJobseekerSubscriptionLookup);

    this.jobseekerSubscriptionSpecializations$ = this.store.select(selectJobseekerSubscriptionSpecializations);

    this.formInitialValue$ = this.store.pipe(select(selectSubscriptionFormInitialValue));

    this.isLoading$ = this.store.pipe(select(selectJobseekerSubscriptionIsLoading));
  

    this.store.dispatch(loadJobseekerSubscriptionLookup());

    this.store.dispatch(loadSubscription());
  }

  onSubscribe(specializationIds: string[], isEditMode: boolean, code: string) {
      const value = this.subscriptionForm.value;

      if (this.subscriptionForm.valid && specializationIds.length > 0) {

        this.store.dispatch(updateSubscription({
          payload: {
            SpecializationIds: specializationIds,
            LocationIds: value.localities ?? [],
            SeniorityLevelIds: value.seniorityLevels ?? [],
          }
        }));
      }

  }

  onToggleSpecialization(specialization: JobseekerSpecializationViewModel, event: MatCheckboxChange) {
      this.store.dispatch(updateSelectedSpecializations({ payload: { specialization: specialization, checked: event.checked } }));
  }

  onCancelSubscribe(){
    this.router.navigate(['/jobseeker/subscription']);
  }
}
